import { STANDARD_PACKAGE_TYPE } from "../data/static-data";
import { validators } from "./validators";

export const validateShipmentItem = (item, packageType) => {
    const errors = [];

    if (!item) {
        return ["Item is required"];
    }

    if (validateOriginalName(item["original-name"])) {
        errors.push(validateOriginalName(item["original-name"]));
    }

    if (validateEnName(item["en-name"])) {
        errors.push(validateEnName(item["en-name"]));
    }

    if (validateTrName(item["tr-name"])) {
        errors.push(validateTrName(item["tr-name"]));
    }

    if (validateGtipCode(item["gtip-code"])) {
        errors.push(validateGtipCode(item["gtip-code"]));
    }

    if (
        packageType === STANDARD_PACKAGE_TYPE &&
        validateMarketLink(item["link"]) !== null
    ) {
        errors.push(validateMarketLink(item["link"]));
    }

    if (validatePrice(item["value-for-one"])) {
        errors.push(validatePrice(item["value-for-one"]));
    }

    if (validateItemsCount(item["count"])) {
        errors.push(validateItemsCount(item["count"]));
    }

    if (validateOriginCountry(item["country-code"])) {
        errors.push(validateOriginCountry(item["country-code"]));
    }

    return errors;
};

export const validateOriginalName = (originalName) => {
    if (originalName === "") {
        return "errors.shipment_item.original_name.required"
    }
    if (originalName.length < 2 || originalName.length > 300) {
        return "errors.shipment_item.original_name.length";
    }
    return null;
};

export const validateEnName = (enName) => {
    if (enName === "") {
        return "errors.shipment_item.en_name.required";
    }
    if (enName.length < 2 || enName.length > 300) {
        return "errors.shipment_item.en_name.length";
    }

    return null;
};

export const validateTrName = (trName) => {
    if (trName === "") {
        return "errors.shipment_item.tr_name.required";
    }

    if (trName.length < 2 || trName.length > 300) {
        return "errors.shipment_item.tr_name.length";
    }

    return null;
};

export const validateGtipCode = (gtipCode) => {
    if (gtipCode === "") {
        return null;
    }

    if (validators.ValidateNumber(gtipCode)) {
        return "errors.shipment_item.gtip_code.number";
    }

    if (gtipCode.toString().length < 4) {
        return "errors.shipment_item.gtip_code.min_4";
    }

    return null;
};

export const ValidateWeight = (weight) => {
    if (weight === "") {
        return "errors.shipment_item.weight.required";
    }
    if (validators.ValidateNumber(weight)) {
        return "errors.shipment_item.weight.number";
    }
    if(+weight > 1000) {
        return "errors.shipment_item.weight.max_1000";
    }
    if (weight.toString().split(".").length > 1 && weight.toString().split(".")[1].length > 2) {
        return "errors.shipment_item.weight.max_2_decimal_places";
    }

    return null;
};

export const validateMarketLink = (marketLink) => {
    if (marketLink === "") {
        return "errors.shipment_item.market_link.required";
    }
    if (validators.ValidateURL(marketLink)) {
        return "errors.shipment_item.market_link.invalid_format";
    }
    return null;
};

export const validatePrice = (price) => {
    if (price === "") {
        return "errors.shipment_item.price.required";
    }
    if (validators.ValidateNumber(price)) {
        return "errors.shipment_item.price.number";
    }
    return null;
};

export const validateItemsCount = (itemsCount) => {
    if (itemsCount === "") {
        return "errors.shipment_item.count.required";
    }
    if (validators.ValidateNumber(itemsCount)) {
        return "errors.shipment_item.count.number";
    }
    if (parseInt(itemsCount) < 1) {
        return "errors.shipment_item.count.min_1";
    }
    return null;
};

export const validateOriginCountry = (originCountry) => {
    if (originCountry === "") {
        return "errors.shipment_item.origin_country.required";
    }
    return null;
};
